import React from 'react';
import { LanguageProvider } from './i18n/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { OpeningLead } from './components/OpeningLead';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalCost } from './components/EmotionalCost';
import { MechanismSection } from './components/MechanismSection';
import { PortfolioSection } from './components/PortfolioSection';
import { AboutSection } from './components/AboutSection';
import { TransformationVision } from './components/TransformationVision';
import { IncludedSection } from './components/IncludedSection';
import { SupplyStoreBanner } from './components/SupplyStoreBanner';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { OneLinersSection } from './components/OneLinersSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-brand-cream flex flex-col" data-id="element-1">
        <Header data-id="element-2" />

        <main className="flex-grow" data-id="element-3">
          <Hero data-id="element-4" />
          <OpeningLead data-id="element-5" />
          <ProblemSection data-id="element-6" />
          <EmotionalCost data-id="element-7" />
          <MechanismSection data-id="element-8" />
          <PortfolioSection data-id="element-9" />
          <AboutSection data-id="element-10" />
          <TransformationVision data-id="element-11" />
          <IncludedSection data-id="element-12" />
          <SupplyStoreBanner data-id="element-13" />
          <GuaranteeSection data-id="element-14" />
          <UrgencySection data-id="element-15" />
          <OneLinersSection data-id="element-16" />
          <FAQSection data-id="element-17" />
          <FinalCTA data-id="element-18" />
        </main>

        <Footer data-id="element-19" />
      </div>
    </LanguageProvider>;
}